"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutDto = void 0;
class LayoutDto {
    _id;
    _organizationId;
    _environmentId;
    _creatorId;
    _parentId;
    name;
    identifier;
    description;
    channel;
    content;
    contentType;
    variables;
    isDefault;
    isDeleted;
    createdAt;
    updatedAt;
}
exports.LayoutDto = LayoutDto;
//# sourceMappingURL=layout.dto.js.map